import React, { createContext, useState, useEffect } from 'react';
import { getUserData } from '../components/Api';
import { useNavigate } from 'react-router-dom'; // No need to wrap with Router here

export const AuthContext = createContext({
  isAuthenticated: false, 
  user: null,
  login: () => {}, 
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');

    if (token && storedUser) {
      setIsAuthenticated(true);
      setUser(JSON.parse(storedUser));
    } else if (token) {
      getUserData(token)
        .then(data => {
          if (data) {
            setIsAuthenticated(true);
            setUser(data);
            localStorage.setItem('user', JSON.stringify(data));
          }
        })
        .catch(error => {
          console.error('Failed to fetch user data:', error);
          logout();
        });
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
    navigate('/user'); // Redirect to user data page after login
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children} {/* Render children here */}
    </AuthContext.Provider>
  );
};
